import { ComponentInstall } from "../../utils";
import Range from "./src";

export default ComponentInstall(Range);
